<div class="label-container" data-test="labelContainer" #labelContainerEl aria-hidden="true">
    <div 
      #labelEl
      data-test="labelElement" 
      class="label"
      [ngClass]="{
        'label--selected': selected,
        'label--glow': label.pinGlow,
        'label--annotation': label.theme === 'annotation',
        'label--classic': label.theme === 'classic',
        'label--invert': isBackgroundDark,
        'label--studio': label.theme === 'studioNext',
        'label--context': label.theme === 'context',
        'label--screenshot-mode': screenshotMode,
        'label--auto-fit': fit === 'auto',
        'label--opaque': opaque
      }">
      
      <!-- Pin -->
      <div #pin class="label__pin">
        <app-label-pin
          [label]="label"
          [labelTheme]="label.theme"
          [selected]="selected"
          [sequence]="sequence"></app-label-pin>
        
        <!-- Glow -->
        <div class="label__glow"></div>
      </div>
  
      <!-- Wire -->
      <div class="label__wire" [ngClass]="{'label__wire--collapse': isCollapsed || tagCollapsed || label.hideWire }" #wire></div>
  
      <!-- Tag -->
      <div 
        #tag
        class="label__tag"
        [ngClass]="{
          'label__tag--collapse': isCollapsed || tagCollapsed,
          'label__tag--collapsible': label.collapseDescription,
          'label__tag--floating': label.hideWire,
          'label__tag--draggable': tagDraggable
        }">

        <div class="label__header">
          <div class="label__title" data-test="labelTitle" #title>
            <ng-content select="[label-header]"></ng-content>
          </div>

          <div class="label__more" *ngIf="hasContent && label.collapseDescription">
            <app-icon icon="caret-right"></app-icon>
          </div>
          
          <!-- Actions -->
          <div class="label__actions" appEventFence>
            <ng-content select="[label-actions]"></ng-content>
          </div>
        </div>
  
        <!-- Body -->
        <div 
          class="label__body" 
          *ngIf="hasContent"
          [ngClass]="{'label__body--collapse': isCollapsed || descriptionCollapsed}">
            <ng-content select="[label-body]"></ng-content>
        </div>
  
        <!-- More -->
        <ng-content select="[label-more]"></ng-content>

      </div>
    </div>
  </div>